import classes from '../styles.module.scss';
import { createCn } from '../../../helpers/utils';

const cn = createCn('files', classes);

const BARS = [
  { height: '55%', delay: '0s', gold: false },
  { height: '100%', delay: '0.2s', gold: false },
  { height: '45%', delay: '0.4s', gold: true },
  { height: '80%', delay: '0.1s', gold: false },
] as const;

const WaveformBars = () => (
  <div className={cn('wave-bars')} aria-hidden>
    {BARS.map((bar, i) => (
      <span
        key={i}
        className={cn('wave-bar', { gold: bar.gold })}
        style={{ height: bar.height, animationDelay: bar.delay }}
      />
    ))}
  </div>
);

export default WaveformBars;
